import classNames from 'classnames';

/*
@sm refers to a container breakpoint set by className="sui-@container".
For details, see the Stencil Container Queries feature documentation.
*/

// Centralized breakpoint constants for consistency
export const BREAKPOINTS = {
  XS: 350,
  SM: 576,
  MD: 896,
  LG: 1280,
  FALLBACK_SM: 544,
  FALLBACK_MD: 1100
};

export const showAboveSmBreakpoint = classNames(
  'sui-hidden',
  '@sm:sui-block'
);

export const showBelowSmBreakpoint = classNames(
  'sui-block',
  '@sm:sui-hidden'
);

export const showAboveSmBreakpointIf = (condition) => classNames('sui-hidden', { '@sm:sui-block': condition });

// Adding a custom class to a card overwrites the default classes
export const defaultCardContentProps = classNames(
  'sui-flex',
  'sui-overflow-hidden',
  'sui-p-4',
  'sui-gap-4',
  'sui-flex-col'
);

export const quoteTitleStyles = classNames(
  'sui-text-base',
  '@2xl:sui-text-lg',
  'sui-text-primary',
  'sui-font-bold',
  'sui-capitalize'
);

export const quoteCardTitleStyles = classNames(
  'sui-text-2xl',
  '@5xl:sui-text-3xl',
  'sui-text-primary',
  'sui-font-display',
  'sui-capitalize'
);